
// BranchContactsTabs.jsx
import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  Grid,
  Paper,
  Typography,
  Divider,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// --- mock data (replace with your own) ---
const branches = [
  {
    id: 'hou',
    name: 'Houston Branch',
    contacts: [
      { id: 'c1', name: 'Alice Parker', role: 'Manager', phone: '555-0101', email: 'alice@company.com' },
      { id: 'c2', name: 'Brian Lee', role: 'Support', phone: '555-0102', email: 'brian@company.com' },
    ],
  },
  {
    id: 'dal',
    name: 'Dallas Branch',
    contacts: [
      { id: 'c3', name: 'Carol Chen', role: 'Sales', phone: '555-0201', email: 'carol@company.com' },
    ],
  },
  {
    id: 'atl',
    name: 'Head Office',
    contacts: [
      { id: 'c4', name: 'Diego Romero', role: 'Ops', phone: '555-0301', email: 'diego@company.com' },
      { id: 'c5', name: 'Eve Patel', role: 'Admin', phone: '555-0302', email: 'eve@company.com' },
      { id: 'c5', name: 'Fred Nerk', role: 'HR', phone: '555-0302', email: 'eve@company.com' },
      { id: 'c5', name: 'James Pattrson', role: 'HR', phone: '555-0302', email: 'eve@company.com' },
      { id: 'c5', name: 'John Doe', role: 'Admin', phone: '555-0302', email: 'eve@company.com' },

    ],
  },
];

// a11y helpers
function a11yProps(index) {
  return {
    id: `branch-tab-${index}`,
    'aria-controls': `branch-tabpanel-${index}`,
  };
}

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`branch-tabpanel-${index}`}
      aria-labelledby={`branch-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

export default function BranchContactsTabs() {
  const [tabIndex, setTabIndex] = React.useState(0);
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (_, newIndex) => setTabIndex(newIndex);

  return (
    <Box>
      <Tabs
        value={tabIndex}
        onChange={handleChange}
        variant={isSmall ? 'scrollable' : 'standard'}
        scrollButtons={isSmall ? 'auto' : undefined}
        aria-label="Branch contact tabs"
      >
        {branches.map((b, idx) => (
          <Tab key={b.id} label={b.name} {...a11yProps(idx)} />
        ))}
      </Tabs>

      {branches.map((b, idx) => (
        <TabPanel key={b.id} value={tabIndex} index={idx}>
          <Typography variant="h2" gutterBottom>{b.name} Contacts</Typography>
          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={2}>
            {b.contacts.map((c) => (
              <Grid item xs={12} sm={6} md={4} key={c.id}>
                <Paper variant="outlined" sx={{ p: 1 }}>
                  <Typography variant="h4" fontWeight={600}>
                    {c.name}
                  </Typography>
                  {c.role && (
                    <Typography variant="h6" color="text.secondary">
                      {c.role}
                    </Typography>
                  )}
                  {c.phone && (
                    <Typography variant="h6" sx={{ mt: 1 }}>
                      📞 {c.phone}
                    </Typography>
                  )}
                  {c.email && (
                    <Typography variant="h6">
                      ✉️ <a href={`mailto:${c.email}`}>{c.email}</a>
                    </Typography>
                  )}
                </Paper>
              </Grid>
            ))}
            {b.contacts.length === 0 && (
              <Grid item xs={12}>
                <Typography color="text.secondary">No contacts available.</Typography>
              </Grid>
            )}
          </Grid>
        </TabPanel>
      ))}
    </Box>
  );
}
